import Vue from "vue";
import {
  hasAllPermission,
  hasAnyPermission
} from "../utils/permission_directive.js";
const Plugins = [hasAllPermission, hasAnyPermission];

Plugins.map(plugin => {
  Vue.use(plugin);
});

export default Vue;
